module.exports = __webpack_public_path__ + "img/eoapp_AQUA_komplett.da23300b.svg";